export default __webpack_public_path__ + "static/media/Teleport Delayed.b9068fcb.wav";